import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'
import SeatingPlan from './SeatingPlan.vue'

window.customElements.define('pretix-seat', class extends HTMLElement {})
window.customElements.define('pretix-seating-plan', wrap(Vue, SeatingPlan))
